

export default {
    path: 'md',
    name: 'project-model',
    props: true,
    component: () => import("@/components/temp/Temp"),
}